import { Link, useNavigate } from 'react-router-dom'
import { styled } from '../../../lib/stitches'
import { useNews } from '../../../queries/news'
import Button from '../../core/Button/Button'
import CenteredLoadingAnimation from '../../core/CenteredLoadingAnimation'
import { Box } from '../../core/Components'
import { PlusIcon } from '../../core/icons'
import Text from '../../core/Text/Text'
import { InternalEndpoint } from '../../Internal'
import { NewsItem } from '../../platform/dashboard/news/NewsItem'

const StyledNewsGrid = styled('div', {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridGap: '16px',
  '@mobile': {
    gridTemplateColumns: '1fr 1fr'
  },
  '@tablet': {
    gridTemplateColumns: '1fr 1fr 1fr'
  }
})

export const News = () => {
  const newsQuery = useNews({ perPage: 100, order: 'desc' })
  const navigate = useNavigate()

  return (
    <>
      <Text size="24" css={{ marginBottom: '$16' }}>
        News
      </Text>
      {newsQuery.isLoading && <CenteredLoadingAnimation />}
      {!newsQuery.isLoading && (
        <StyledNewsGrid>
          {newsQuery.data.pages.map((page) =>
            page.data.map((news) => (
              <Box
                key={news.id}
                onClick={(event) => {
                  event.preventDefault()
                  navigate(`/${InternalEndpoint}/news/${news.id}`)
                }}
                css={{
                  [`&:hover #edit-${news.id}`]: {
                    display: 'inline-flex'
                  },
                  position: 'relative'
                }}
              >
                <Button
                  id={`edit-${news.id}`}
                  type="white"
                  css={{
                    display: 'none',
                    position: 'absolute',
                    right: '5px',
                    top: '5px',
                    zIndex: 20
                  }}
                >
                  Edit
                </Button>
                <NewsItem news={news} disableSegmentTracking />
              </Box>
            ))
          )}
          <Link to={`/${InternalEndpoint}/news/create`}>
            <Box
              css={{
                aspectRatio: 3 / 2,
                backgroundColor: '$gray02',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '$8',
                gap: '8px',
                height: '100%',
                transition: 'background-color 0.1s ease',
                '&:hover': {
                  backgroundColor: '$gray04'
                }
              }}
            >
              <PlusIcon />
              Add new
            </Box>
          </Link>
        </StyledNewsGrid>
      )}
    </>
  )
}
